import { createUseStyles } from "react-jss";
import { GridColumnWidth } from "../types/table";
import { isArrayDefined } from "./isDefined";
import { COL_PIXEL_MAP } from "./sizing";
export function getGridColumns({ headings, hasDrawer, actionAtEnd, actionAtStart, }) {
    if (!isArrayDefined(headings))
        return undefined;
    let columns = "";
    const hasSomeWidths = headings.some((heading) => heading.width);
    if (hasSomeWidths) {
        columns = getWidthColumns(headings);
    }
    else {
        columns = getDefaultColumns(headings);
    }
    columns = hasDrawer ? `${columns} 100px` : columns;
    columns = actionAtStart ? `32px ${columns}` : columns;
    columns = actionAtEnd ? `${columns} 33px` : columns;
    return columns;
}
export function getDefaultColumns(headings) {
    let columns = "";
    headings?.forEach((_, i) => {
        if (i === 0)
            return (columns = GridColumnWidth.Fragment);
        return (columns += ` ${GridColumnWidth.Fragment}`);
    });
    return columns;
}
export function getWidthColumns(headings) {
    const setGridColumns = (headings) => {
        let gridColumns = [];
        headings.forEach((heading) => {
            if (Array.isArray(heading.width) || typeof heading.width == "object") {
                gridColumns.push(GridColumnWidth.Fragment);
            }
            else {
                if (heading.width === GridColumnWidth.AUTO) {
                    gridColumns.push(GridColumnWidth.Fragment);
                }
                else {
                    gridColumns.push(heading.width ?? GridColumnWidth.Fragment);
                }
            }
        });
        return gridColumns;
    };
    return buildGridColumnWidthToString(setGridColumns(headings)) ?? "";
}
export const buildGridColumnWidthToString = (columns) => columns.reduce((gridColumns, column) => gridColumns + " " + COL_PIXEL_MAP.get(column), "");
function getGridTemplateColumns(headings, drawer, hasActionAtStart, hasActionAtEnd) {
    const gridColumnsString = getGridColumns({
        headings,
        hasDrawer: !!drawer,
        actionAtStart: hasActionAtStart,
        actionAtEnd: !!hasActionAtEnd,
    });
    const numberOfColumns = headings.length;
    let gridColumns = {
        gridTemplateColumns: `${gridColumnsString}`,
        "-ms-grid-columns": `${gridColumnsString}`,
    };
    if (drawer && numberOfColumns) {
        gridColumns = {
            ...gridColumns,
            "grid-template-rows": "auto",
            gridTemplateAreas: `
          "${getMainTemplateAreas(hasActionAtStart ? numberOfColumns + 1 : numberOfColumns)} data-drawer-toggle ${hasActionAtEnd ? "data-action" : ""}"
          "${getDrawerTemplateAreas(numberOfColumns +
                1 +
                (hasActionAtStart ? 1 : 0) +
                (hasActionAtEnd ? 1 : 0))}"
        `,
        };
    }
    else if (numberOfColumns) {
        gridColumns = {
            ...gridColumns,
            gridTemplateAreas: `"${getMainTemplateAreas(hasActionAtStart ? numberOfColumns + 1 : numberOfColumns)} ${hasActionAtEnd ? "data-action" : ""}"`,
        };
    }
    return gridColumns;
}
const useStyles = createUseStyles({
    // @ts-ignore
    gridColumns: ({ headings, drawer, hasActionAtStart, hasActionAtEnd }) => getGridTemplateColumns(headings, drawer, hasActionAtStart, hasActionAtEnd),
});
export function useGridColumnsClasses(props) {
    // @ts-ignore
    return useStyles(props);
}
export const DATA_COL_INDEX = "data-colindex-";
export const getMainTemplateAreas = (columns) => {
    if (typeof columns == "number") {
        let colIndexMain = "";
        for (let index = 0; index < columns; index++) {
            colIndexMain += `${DATA_COL_INDEX}${index + 1} `;
        }
        return colIndexMain;
    }
};
export const DATA_COL_INDEX_DRAWER = "data-colindex-drawer";
export const getDrawerTemplateAreas = (columns) => {
    if (typeof columns == "number") {
        let colIndexDrawer = "";
        for (let index = 0; index < columns; index++) {
            colIndexDrawer += `${DATA_COL_INDEX_DRAWER} `;
        }
        return colIndexDrawer;
    }
};
